import createReducer from '../createReducer';

const initialState = {
    subscriptionEvents: [],
    subscriptionPlans: [],
    currentSubscription: null,
    currentPlan: null,
    planEvents: [],
    events: [],
    loading: false,
    error: null,
    
    // XHR states - Use TXHR
    getSubscriptionsXHR: null,
    createSubscriptionXHR: null,
    updateSubscriptionXHR: null,
    deleteSubscriptionXHR: null,
    getPlansXHR: null,
    getPlanXHR: null,
    createPlanXHR: null,
    updatePlanXHR: null,
    deletePlanXHR: null,
    getPlanEventsXHR: null,
    linkEventToPlanXHR: null,
    duplicatePlanXHR: null,
    // Price Groups
    priceGroups: [],
    getPriceGroupsXHR: null,
    getPriceGroupsByPackageXHR: null,
    createPriceGroupXHR: null,
    updatePriceGroupXHR: null
};

const reducer = createReducer('subscription', initialState);

export default reducer;
